import { createAsyncActionType } from '.';

export const ACCESS_STATISTICS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'ACCESS_STATISTICS_LIST_GET'
);

export const ACTIVITY_STATISTICS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'ACTIVITY_STATISTICS_LIST_GET'
);

export const ACTIVITY_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'ACTIVITY_LIST_GET'
);

export const CATEGORY_STATISTICS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'CATEGORY_STATISTICS_LIST_GET'
);

export const CATEGORY_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'CATEGORY_LIST_GET'
);

export const TUTOR_STATISTICS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'TUTOR_STATISTICS_LIST_GET'
);

export const TUTOR_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'TUTOR_LIST_GET'
);

export const COURSE_STATISTICS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'COURSE_STATISTICS_LIST_GET'
);

export const LOGS_LIST_GET = createAsyncActionType(
  'supervisorStats',
  'LOGS_LIST_GET'
);

export const CACHE_INVALIDATE = createAsyncActionType(
  'supervisorStats',
  'CACHE_INVALIDATE'
);

export const LAST_CACHE_INVALIDATE_GET = createAsyncActionType(
  'supervisorStats',
  'LAST_CACHE_INVALIDATE_GET'
);
